import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import PricingPage from './pages/PricingPage';
import DocumentsPage from './pages/DocumentsPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import CreditsPage from './pages/CreditsPage';
import Footer from './components/Footer';
import { AuthProvider } from './contexts/AuthContext';
import { StripeProvider } from './contexts/StripeContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles/theme.css';



export default function App() {
  // console.log('App component rendering');
  return (
    <AuthProvider>
      <StripeProvider>
        <ThemeProvider>
          <Router>
            <div className="flex flex-col min-h-screen">
              <div className="flex-grow">
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/home" element={<HomePage />} />
                  <Route path="/documents" element={<DocumentsPage />} />
                  <Route path="/pricing" element={<PricingPage />} />
                  <Route path="/credits" element={<CreditsPage />} />
                  <Route path="success" element={<PaymentSuccessPage />} />
                  <Route path="cancel" element={<PaymentCancelPage />} />
                </Routes>
              </div>
              <Footer />
            </div>
          </Router>
        </ThemeProvider>
      </StripeProvider>
    </AuthProvider>
  );
}
